
<div class="clock-container clock2">
  <div class="time">{{date | date:"dd/MM/yyyy"}} - {{date | date: "HH:mm:ss"}}</div>
</div>
